import { useDispatch, useSelector } from 'react-redux';
import { Modal, ModalHeader, ModalBody, Container, Col, Row } from 'reactstrap';
import { actions } from '../../context';
import EditConversionPimsForm from '../Forms/EditConversionPimsForm';

const EditConversionPimsModal = ({ practiceName, practiceId }) => {
    const dispatch = useDispatch();

    const conversion = useSelector(
        (state) => state.conversions.modalConversion
    );

    const toggleModal = (bool) =>
        dispatch(actions.toggle.toggleEditConversionPimsModalOpen(bool));

    const closeModal = () => toggleModal(false);

    const isOpen = useSelector(
        (state) => state.toggle.isEditConversionPimsModalOpen
    );

    return (
        <Modal
            isOpen={isOpen}
            toggle={() => isOpen && closeModal}
            className="modal-md text-light"
            contentClassName="bg-secondary"
            centered={true}
            style={{ minWidth: '30vw' }}
            size="lg">
            <ModalHeader className="d-inline-block w-100 h-100">
                <Row>
                    <Col lg={8} sm="6" className="d-inline-block w-100 h-100">
                        <h4>Change Source PIMS</h4>
                    </Col>
                </Row>
            </ModalHeader>
            <ModalBody className="justify-content-center">
                <Container>
                    <EditConversionPimsForm
                        practiceName={practiceName}
                        practiceId={practiceId}
                        conversion={conversion}
                        submitCB={closeModal}
                        closeCB={closeModal}
                    />
                </Container>
            </ModalBody>
        </Modal>
    );
};

export default EditConversionPimsModal;
